import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=5cad16a0"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cad16a0')) {
      api.createRecord('5cad16a0', component.options)
    } else {
      api.reload('5cad16a0', component.options)
    }
    module.hot.accept("./Pagination.vue?vue&type=template&id=5cad16a0", function () {
      api.rerender('5cad16a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/List/Pagination.vue"
export default component.exports